export default __webpack_public_path__ + "static/media/CV3.5134c5e9.png";